declare namespace $ {

	type $mol_frame__html_shm_hitalama_map_widget_float_code_html_bench_result_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_html_bench_result['state'] >
		,
		ReturnType< $mol_frame['html'] >
	>
	export class $shm_hitalama_map_widget_float_code_html_bench_result extends $shm_hitalama_map_widget_float_code_bench_result {
		Frame( ): $mol_frame
		result_view( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=result.view.tree.d.ts.map